// Cycle-16 composer scroll-down floating-action-button. Anchored above
// the composer when the user has scrolled away from the latest message.
// Pure controlled — host owns scroll state and wires the press handler.

import { ArrowDown } from 'lucide-react-native';
import React from 'react';
import { Pressable, StyleSheet } from 'react-native';
import { useColorScheme } from '../../foundations/colorScheme';
import { tokens } from '../../design-system/tokens';

export interface ComposerScrollDownFabProps {
  // Accepted for caller compatibility; intentionally not rendered (no badge per Figma 2804:26738).
  unreadCount?: number | undefined;
  onPress: () => void;
  testID?: string | undefined;
}

export const ComposerScrollDownFab = React.memo<ComposerScrollDownFabProps>(
  ({ onPress, testID }) => {
    const scheme = useColorScheme();
    const colorScheme: 'light' | 'dark' = scheme === 'dark' ? 'dark' : 'light';
    const colors = tokens.color.semantic[colorScheme];

    const backgroundColor = colorScheme === 'dark' ? '#222429' : colors.surface.secondary;
    const iconColor = colorScheme === 'dark' ? '#FFFFFF' : colors.text.primary;

    return (
      <Pressable
        onPress={onPress}
        accessibilityRole="button"
        accessibilityLabel="Scroll to latest"
        style={[styles.fab, { backgroundColor }]}
        testID={testID}
      >
        <ArrowDown size={20} color={iconColor} />
      </Pressable>
    );
  },
);

ComposerScrollDownFab.displayName = 'ComposerScrollDownFab';

const styles = StyleSheet.create({
  fab: {
    width: 32,
    height: 32,
    borderRadius: tokens.radius.pill,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
